import React, { Component } from "react";
import _ from "lodash";

export class Settings extends Component {

  applyAll = (toWhat) => {
    this.props.stores.map(s => this.props.onStoreChange(s, toWhat));
  }
  

  render() {

    const { stores } = this.props;

    const columnSize = (stores.length / 3) + (stores.length % 3 > 0 ? 1 :0);

    const columnData = _.chunk(stores, columnSize);

    return (
        <div className="settings">
          <p>
      There are {stores.length} stores that can be searched. The stores with a check mark are the stores that will be included in a search. If you wish to remove a store from a search simply uncheck the store.
      </p>

      <div className="row">
        {columnData.map(c => <div key={columnData.indexOf(c)} className="col-md-4 col-sm-6">
          {c.map(i => <div key={i.handlerName}><input key={i.handlerName} className="mr-2" type="checkbox" checked={i.enabled} onChange={() => this.props.onStoreChange(i)} /><span>{i.handlerName}</span><i className={i.isOk ? "fas fa-circle ok" :"fas fa-circle notok"}></i></div>)}</div>)}
      </div>

      <div className="mb-3 mt-3">
        <button className="btn btn-sm btn-outline-primary mr-2" onClick={() => this.applyAll(true)}>Select All</button>
        <button className="btn btn-sm btn-outline-primary" onClick={() => this.applyAll(false)}>Deselect All</button>
      </div>

        <h4>Other settings</h4>

        <div><input className="mr-2" type="checkbox" checked={this.props.cookieAcceptance} onChange={() => this.props.onAcceptanceChange(!this.props.cookieAcceptance)} /><span>Cookie / LocalStorage policy accepted</span></div>

        <p className="mt-2">This site stores settings locally in your browser to improve the user experience. If you would like to clear this data, click the 'Reset settings' button below.</p>
        <button className="btn btn-danger" onClick={this.props.onClearSettings}>Reset settings</button>

    </div>);
  }

}
